<cft-bottom-navigation>
  <div class="h-layout flex h-fit flex-col pb-sm">
    <div class="flex h-fit w-full flex-col gap-xs pt-sm sm:flex-row sm:items-center sm:justify-between">
      @if (benefits.length) {
        <ul class="flex gap-xs">
          @for (benefit of benefits; track benefit) {
            <li class="text-xs text-president-400">
              <fa-icon class="text-green-500" [icon]="checkIcon"></fa-icon> {{ benefit }}
            </li>
          }
        </ul>
      }

      <div class="flex h-fit items-center justify-between justify-center gap-sm">
        <ng-content select="[content=formCta]"></ng-content>
        <ng-content select="[content=mainCta]"></ng-content>
      </div>
    </div>
    @if (showGuarantee) {
      <div class="flex flex-row-reverse pt-xs text-xs text-grey-700">
        <ng-content select="[content=guaranteeText]"></ng-content>
      </div>
    }
  </div>
</cft-bottom-navigation>
